import { useCallback as p, useState as w, useEffect as y } from "react";
import "./firebase-d0134a8f.js";
import { a as f, i as k, b as $, f as I, g as E } from "./@firebase-868b0e52.js";
import { l as g } from "./node-forge-b3503c74.js";
import "./myasurion-shared.mixpanel.es.js";
import "./contentful-a9b11b75.js";
import { c as h, a as u } from "./usehooks-ts-53aa4768.js";
import { a as C, g as T } from "./domains-162ab8d8.js";
const c = "at", m = "session-storage", N = (t) => {
  const e = p(() => {
    if (typeof window > "u")
      return t;
    try {
      const n = window.sessionStorage.getItem(c);
      return n ? S(n) : t;
    } catch (n) {
      return console.warn(`Error reading account data “${c}”:`, n), t;
    }
  }, [t, c]), [o, r] = w(e), s = h((n) => {
    typeof window > "u" && console.warn(
      `Tried setting account data “${c}” even though environment is not a client`
    );
    try {
      const a = n instanceof Function ? n(o) : n;
      window.sessionStorage.setItem(c, JSON.stringify(a)), r(a), window.dispatchEvent(new Event(m));
    } catch (a) {
      console.warn(`Error setting account data key “${c}”:`, a);
    }
  });
  y(() => {
    r(e());
  }, []);
  const i = p(
    (n) => {
      n != null && n.key && n.key !== c || r(e());
    },
    [c, e]
  );
  return u("storage", i), u(m, i), [o, s];
}, R = () => {
}, D = (t) => (t.indexOf("/") === 0 && (t = t.substring(1)), `${window.location.origin}/${t}`), U = (t, e) => !!(t && e && (t.profileId || t.userId) && e.authorization && e.token);
function S(t) {
  try {
    return t === "undefined" ? void 0 : JSON.parse(t ?? "");
  } catch {
    console.log("parsing error on", { value: t });
    return;
  }
}
const j = () => {
  const t = c, e = d;
  {
    const o = JSON.parse(sessionStorage.getItem(t) || ""), r = JSON.parse(sessionStorage.getItem(e) || "");
    return {
      token: o.token || "",
      authorization: o.authorization || "",
      userId: r && r.userId ? r.userId : "",
      profileId: r && r.profileId ? r.profileId : ""
    };
  }
}, B = ({ method: t = "GET", httpPath: e = "/", token: o }, r) => {
  const s = g.hmac.create();
  return s.start("sha512", r), s.update(`${t}_${e}_${o}`), s.digest().toHex();
}, K = (t) => {
  var r, s;
  if (!t)
    return;
  let e;
  try {
    e = new URL(t ?? "");
  } catch {
    e = new URL(`${window.location.href}${t}`);
  }
  return (s = (r = /\/(sqa-stage|sqa|uat|dev|prodgreen|prod)?(?<path>.*)/.exec(e.pathname)) == null ? void 0 : r.groups) == null ? void 0 : s.path;
}, M = (t) => {
  const e = g.md.sha256.create();
  return e.update(t.toString()), e.digest().toHex();
}, _ = (t, e, o = 128, { iterations: r, keySize: s, hasher: i } = {
  iterations: 1e4,
  keySize: 64,
  hasher: g.md.algorithms.sha512.create()
}) => {
  const n = g.pkcs5.pbkdf2(t, e, r, s, i);
  return g.util.bytesToHex(n).slice(0, o);
}, q = (t) => `${C().toLowerCase()}-${t.toLowerCase()}`;
async function b(t) {
  let e;
  if (!t || Object.keys(t).length === 0)
    return;
  f().length === 0 ? e = k(t) : e = f()[0];
  const o = $(e);
  return o.settings.minimumFetchIntervalMillis = 6e4, await I(o), o;
}
const G = async (t, e) => {
  if (!t || Object.keys(t).length === 0)
    return;
  const o = await b(t);
  return o ? E(o, e).asString() : void 0;
}, P = (t) => {
  var e, o, r, s, i;
  if ((o = (e = t == null ? void 0 : t.toString()) == null ? void 0 : e.toLowerCase()) != null && o.includes("by"))
    return t;
  {
    (s = (r = t == null ? void 0 : t.toString()) == null ? void 0 : r.toUpperCase()) != null && s.endsWith("H") && (t = (i = t == null ? void 0 : t.toString()) == null ? void 0 : i.slice(0, -1));
    const n = t >= 12 ? "pm" : "am";
    let a = t > 12 ? t - 12 : t;
    return a = a == "00" ? 12 : a, `By ${a}${n}`;
  }
}, v = () => {
  console.log("%c @MGPD/myasurion-shared v2.31.2  ", "background: #9747DD; color: #FFF");
}, W = () => T() === "repair" ? "/portal" : "/", d = "account", l = "session-storage", Q = (t) => {
  const e = p(() => {
    if (typeof window > "u")
      return t;
    try {
      const n = window.sessionStorage.getItem(d);
      return n ? S(n) : t;
    } catch (n) {
      return console.warn(`Error reading account data “${d}”:`, n), t;
    }
  }, [t, d]), [o, r] = w(e), s = h((n) => {
    typeof window > "u" && console.warn(
      `Tried setting account data “${d}” even though environment is not a client`
    );
    try {
      const a = n instanceof Function ? n(o) : n;
      window.sessionStorage.setItem(d, JSON.stringify(a)), r(a), window.dispatchEvent(new Event(l));
    } catch (a) {
      console.warn(`Error setting account data key “${d}”:`, a);
    }
  });
  y(() => {
    r(e());
  }, []);
  const i = p(
    (n) => {
      n != null && n.key && n.key !== d || r(e());
    },
    [d, e]
  );
  return u("storage", i), u(l, i), [o, s];
};
export {
  j as a,
  B as b,
  K as c,
  M as d,
  q as e,
  b as f,
  D as g,
  _ as h,
  U as i,
  G as j,
  v as k,
  W as l,
  N as m,
  R as n,
  S as p,
  P as t,
  Q as u
};
